import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import SpotlightText from "./SpotlightText";
import Impressum from "./Impressum";
import Datenschutz from "./Datenschutz";


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<SpotlightText />} />
        <Route path="/impressum" element={<Impressum />} />
        <Route path="/datenschutz" element={<Datenschutz />} />
      </Routes>

    
    </Router>
  );
}

export default App;
